// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stripe-connect-container {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
}
.stripe-connect-container .header-section {
  text-align: center;
  margin-bottom: 30px;
}
.stripe-connect-container .header-section .stripe-logo {
  width: 120px;
  margin-bottom: 20px;
}
.stripe-connect-container .header-section h1 {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 10px;
  color: #1a1f36;
}
.stripe-connect-container .header-section p {
  color: #697386;
  font-size: 16px;
  line-height: 1.5;
}
.stripe-connect-container .benefits-section {
  margin-bottom: 30px;
}
.stripe-connect-container .benefits-section h2 {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 15px;
  color: #1a1f36;
}
.stripe-connect-container .benefits-section ion-item {
  --padding-start: 0;
  --inner-padding-end: 0;
  --background: transparent;
}
.stripe-connect-container .fees-section {
  margin-bottom: 30px;
}
.stripe-connect-container .fees-section h2 {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 15px;
  color: #1a1f36;
}
.stripe-connect-container .fees-section ion-card {
  margin: 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}
.stripe-connect-container .fees-section ion-card ion-card-content {
  padding: 16px;
}
.stripe-connect-container .fees-section ion-card ion-card-content p {
  font-weight: 500;
  margin-bottom: 10px;
  color: #1a1f36;
}
.stripe-connect-container .fees-section ion-card ion-card-content ul {
  margin: 0;
  padding-left: 20px;
  color: #697386;
}
.stripe-connect-container .fees-section ion-card ion-card-content ul li {
  margin-bottom: 8px;
  line-height: 1.4;
}
.stripe-connect-container .action-section ion-button {
  height: 48px;
  font-weight: 600;
  text-transform: none;
  font-size: 16px;
}`, "",{"version":3,"sources":["webpack://./src/app/stripe-connect-onboarding/stripe-connect-onboarding.page.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,cAAA;EACA,aAAA;AACF;AACE;EACE,kBAAA;EACA,mBAAA;AACJ;AACI;EACE,YAAA;EACA,mBAAA;AACN;AAEI;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AAAN;AAGI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AADN;AAKE;EACE,mBAAA;AAHJ;AAKI;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AAHN;AAMI;EACE,kBAAA;EACA,sBAAA;EACA,yBAAA;AAJN;AAQE;EACE,mBAAA;AANJ;AAQI;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AANN;AASI;EACE,SAAA;EACA,wCAAA;EACA,kBAAA;AAPN;AASM;EACE,aAAA;AAPR;AASQ;EACE,gBAAA;EACA,mBAAA;EACA,cAAA;AAPV;AAUQ;EACE,SAAA;EACA,kBAAA;EACA,cAAA;AARV;AAUU;EACE,kBAAA;EACA,gBAAA;AARZ;AAgBI;EACE,YAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;AAdN","sourcesContent":[".stripe-connect-container {\n  max-width: 600px;\n  margin: 0 auto;\n  padding: 20px;\n\n  .header-section {\n    text-align: center;\n    margin-bottom: 30px;\n\n    .stripe-logo {\n      width: 120px;\n      margin-bottom: 20px;\n    }\n\n    h1 {\n      font-size: 24px;\n      font-weight: 600;\n      margin-bottom: 10px;\n      color: #1a1f36;\n    }\n\n    p {\n      color: #697386;\n      font-size: 16px;\n      line-height: 1.5;\n    }\n  }\n\n  .benefits-section {\n    margin-bottom: 30px;\n\n    h2 {\n      font-size: 18px;\n      font-weight: 600;\n      margin-bottom: 15px;\n      color: #1a1f36;\n    }\n\n    ion-item {\n      --padding-start: 0;\n      --inner-padding-end: 0;\n      --background: transparent;\n    }\n  }\n\n  .fees-section {\n    margin-bottom: 30px;\n\n    h2 {\n      font-size: 18px;\n      font-weight: 600;\n      margin-bottom: 15px;\n      color: #1a1f36;\n    }\n\n    ion-card {\n      margin: 0;\n      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n      border-radius: 8px;\n\n      ion-card-content {\n        padding: 16px;\n\n        p {\n          font-weight: 500;\n          margin-bottom: 10px;\n          color: #1a1f36;\n        }\n\n        ul {\n          margin: 0;\n          padding-left: 20px;\n          color: #697386;\n\n          li {\n            margin-bottom: 8px;\n            line-height: 1.4;\n          }\n        }\n      }\n    }\n  }\n\n  .action-section {\n    ion-button {\n      height: 48px;\n      font-weight: 600;\n      text-transform: none;\n      font-size: 16px;\n    }\n  }\n} "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
